export default __webpack_public_path__ + "static/media/more.286c8856.svg";